import { render, staticRenderFns } from "./CLogo.vue?vue&type=template&id=740798c0&scoped=true&"
import script from "./CLogo.vue?vue&type=script&lang=js&"
export * from "./CLogo.vue?vue&type=script&lang=js&"
import style0 from "./CLogo.vue?vue&type=style&index=0&id=740798c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740798c0",
  null
  
)

export default component.exports